module.exports = __webpack_public_path__ + "static/img/Libra.1681e8ec.jpg";